export default __webpack_public_path__ + "static/PermanentDialog-23139b618adbbb088ef6ef05ec78202d.gif";